import * as React from "react";
import { SVGProps } from "react";
export const EllipsisHorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.5 11.5C5.08333 11.5 4.72933 11.354 4.438 11.062C4.146 10.7707 4 10.4167 4 10C4 9.58333 4.146 9.22933 4.438 8.938C4.72933 8.646 5.08333 8.5 5.5 8.5C5.91667 8.5 6.27067 8.646 6.562 8.938C6.854 9.22933 7 9.58333 7 10C7 10.4167 6.854 10.7707 6.562 11.062C6.27067 11.354 5.91667 11.5 5.5 11.5ZM10 11.5C9.58333 11.5 9.22933 11.354 8.938 11.062C8.646 10.7707 8.5 10.4167 8.5 10C8.5 9.58333 8.646 9.22933 8.938 8.938C9.22933 8.646 9.58333 8.5 10 8.5C10.4167 8.5 10.7707 8.646 11.062 8.938C11.354 9.22933 11.5 9.58333 11.5 10C11.5 10.4167 11.354 10.7707 11.062 11.062C10.7707 11.354 10.4167 11.5 10 11.5ZM14.5 11.5C14.0833 11.5 13.7293 11.354 13.438 11.062C13.146 10.7707 13 10.4167 13 10C13 9.58333 13.146 9.22933 13.438 8.938C13.7293 8.646 14.0833 8.5 14.5 8.5C14.9167 8.5 15.2707 8.646 15.562 8.938C15.854 9.22933 16 9.58333 16 10C16 10.4167 15.854 10.7707 15.562 11.062C15.2707 11.354 14.9167 11.5 14.5 11.5Z"
            fill="currentColor"
        />
    </svg>
);
EllipsisHorizontalIcon.displayName = "EllipsisHorizontalIcon";
